import React, { useState } from "react";
import "./BlogWrapper.scss";
import { blogTagTexts } from "../../data/data";

import BlogCard from "../../components/blogCard/BlogCard";
import { ReactComponent as Search } from "../../assets/svg/search.svg";
import { ReactComponent as Cancel } from "../../assets/svg/cancel.svg";

const BlogWrapper = ({ blogPosts }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleButtonClick = (index) => {
    setActiveIndex(index);
  };

  const handleSearchButtonClick = () => {
    setIsSearching(true);
  };

  const handleSearchCloseClick = () => {
    setIsSearching(false);
    setSearchTerm("");
  };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };
  
  if (!blogPosts) return null;

  return (
    <>
      <section className="section blogTags">
        <article className="blogTags__container container">
          <h3>
            {blogTagTexts[activeIndex] === "All Blogs"
              ? "All Articles"
              : blogTagTexts[activeIndex]}
          </h3>

          <div className="blogTags__container--contents">
            {blogTagTexts.map((tag, index) => (
              <button
                key={index}
                type="button"
                className={`blogTagBtn ${
                  index === activeIndex ? "active-blogTagBtn" : ""
                }`}
                onClick={() => handleButtonClick(index)}
              >
                <span>{tag}</span>
              </button>
            ))}
          </div>

          {!isSearching ? (
            <div className="blogTags__container--search">
              <button
                className="searchButton"
                type="button"
                onClick={handleSearchButtonClick}
              >
                <Search />
              </button>
            </div>
          ) : (
            <div className="blogTags__container--input">
              <input
                type="text"
                placeholder="Type to search..."
                value={searchTerm}
                onChange={handleInputChange}
              />

              <button
                className="searchButton"
                type="button"
                onClick={handleSearchCloseClick}
              >
                <Cancel />
              </button>
            </div>
          )}
        </article>
      </section>

      <section className="section blogWrapper">
        <article className="blogWrapper__container container">
          <div className="blogWrapper__container--contents">
            {blogPosts?.map((data) => (
              <BlogCard blogPosts={data} key={data._id} />
            ))}
          </div>
        </article>
      </section>
    </>
  );
};

export default BlogWrapper;
